import { WithdrawalType } from '@sparkplug/lib';

import { CashOutMethodIcon } from '../components/CashOutMethodIcon';
import { CashOutMethod } from '../types';

export type CashOutDetailsType = {
    label: string;
    warningMessage?: string;
    icon: any;
    fee: number;
    viewName: string;
};

export const ALL_AVAILABLE_METHODS: Record<WithdrawalType, CashOutDetailsType> = {
    [CashOutMethod.VISA]: {
        label: 'Virtual Visa US',
        icon: <CashOutMethodIcon withdrawalMethod={CashOutMethod.VISA} />,
        fee: 0.0,
        viewName: 'Visa',
    },
    [CashOutMethod.VISA_INTERNATIONAL]: {
        label: 'Virtual Visa International',
        icon: <CashOutMethodIcon withdrawalMethod={CashOutMethod.VISA} />,
        fee: 0.0,
        viewName: 'Visa International',
    },
    [CashOutMethod.AMAZON]: {
        label: 'Amazon Gift Card',
        icon: <CashOutMethodIcon withdrawalMethod={CashOutMethod.AMAZON} />,
        fee: 0.0,
        viewName: 'Amazon',
    },
    [CashOutMethod.VENMO]: {
        label: 'Venmo',
        warningMessage: 'Venmo transfer speeds vary and could 1 to 3 business days to complete.',
        icon: <CashOutMethodIcon withdrawalMethod={CashOutMethod.VENMO} />,
        fee: 0.025,
        viewName: 'Venmo',
    },
    [CashOutMethod.ACH]: {
        label: 'ACH',
        warningMessage: 'ACH transfer speeds vary and could take 3 to 5 business days to complete.',
        icon: <CashOutMethodIcon withdrawalMethod={CashOutMethod.ACH} />,
        fee: 0.025,
        viewName: 'ACH',
    },
};
